import FeedbackForm from './FeedbackForm';
import { userActions, userDataSel } from 'src/store/modules/user';
import { IInitialState } from 'src/store/initialState';
import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: any) => {
  return {
    userData: userDataSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onLoad: () => {
    dispatch(userActions.getUserDetails());
  }
});

// export const PureComponent = FeedbackForm;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(FeedbackForm));
interface IDispatchFromProps {
  onLoad(): void;
}
